import { styled } from '@mui/system';

export const DescriptionContainer = styled('div')(({ theme }) => ({
	display: 'block',
	width: '90%',
	marginTop: '2vh',
	marginBottom: theme.spacing(0.5),
	'@media (max-width: 680px)': {
		width: '80vw'
	},
	[theme.breakpoints.down('sm')]: {
		marginLeft: 0,
		width: '80vw'
	}
}));
